import { z } from 'zod';
/**
 * Audit log operation types
 */
export var AuditOperation;
(function (AuditOperation) {
    AuditOperation["Created"] = "CREATED";
    AuditOperation["Updated"] = "UPDATED";
    AuditOperation["Deleted"] = "DELETED";
    AuditOperation["Login"] = "LOGIN";
    AuditOperation["Logout"] = "LOGOUT";
    /**
     * Soft-delete of a credential, written explicitly by the application (KIR-3746).
     * The `api_keys` audit trigger fires on INSERT/DELETE only, so revoking a
     * management API key — an UPDATE — would otherwise leave no audit trail.
     */
    AuditOperation["Revoked"] = "REVOKED";
})(AuditOperation || (AuditOperation = {}));
export const auditLogSchema = z.object({
    id: z.string(),
    tableName: z.string(),
    operation: z.enum([
        AuditOperation.Created,
        AuditOperation.Updated,
        AuditOperation.Deleted,
        AuditOperation.Login,
        AuditOperation.Logout,
        AuditOperation.Revoked,
    ]),
    recordId: z.string().nullable(),
    userId: z.string().nullable(),
    organizationId: z.string().nullable(),
    beforeData: z.record(z.string(), z.unknown()).nullable(),
    afterData: z.record(z.string(), z.unknown()).nullable(),
    changedFields: z.record(z.string(), z.unknown()).nullable(),
    timestamp: z.string(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    // Joined user information for display
    userName: z.string().nullable(),
    userEmail: z.string().nullable(),
});
/**
 * Audit logs list response schema
 */
export const auditLogsListSchema = z.object({
    logs: z.array(auditLogSchema),
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number(),
});
/**
 * Audit logs pagination query params schema
 * Note: organizationId is now in route params, not query params
 */
export const auditLogPaginationSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(25),
});
/**
 * Format user display from audit log
 * Priority: name > email > userId > "System"
 */
export function formatUserDisplay(log) {
    if (log.userName)
        return log.userName;
    if (log.userEmail)
        return log.userEmail;
    if (log.userId)
        return log.userId;
    return 'System';
}
//# sourceMappingURL=audit-logs.js.map